import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'Context/QueryClientContext';
import ObrasApi from 'Data/Obras.api';
import { IObraResponse } from 'Data/interfaces/Obra/IObraListResponse';
import toastHandler from 'Utils/toastHandler';
import { OBRA_QUERY_KEY } from 'Data/keys/QueryKeys';
import { createError, createSuccess, updateError, updateSuccess } from 'Utils/Messages';
import { IDisciplineRequest } from 'Data/interfaces/Obra/IDisciplineRequest';

export const useQueryCreateOrUpdateDiscipline = () => {
  const { mutate, mutateAsync, isPending } = useMutation({
    mutationFn: (variables: IDisciplineRequest) => {
      return ObrasApi.createOrUpdateDiscipline(variables);
    },
    onSuccess: async ({ data }, variables) => {
      await queryClient.cancelQueries({
        queryKey: [OBRA_QUERY_KEY, Number(data.data.ConstructionSiteFk)],
      });

      queryClient.setQueryData<IObraResponse[]>([OBRA_QUERY_KEY], (old) => {
        return old?.map((obra) => {
          if (obra.ConstructionSiteId !== data.data.ConstructionSiteFk) {
            return obra;
          }

          const disciplines = obra.Disciplines || [];
          const index = disciplines.findIndex((discipline: any) => {
            return discipline.ConstructionSiteDisciplinesId === data.data.ConstructionSiteDisciplinesId;
          });

          return {
            ...obra,
            Disciplines: index !== -1
              ? disciplines.map((discipline: any, i: number) => (i === index ? data.data : discipline))
              : [...disciplines, data.data],
          };
        });
      });
      queryClient.setQueryData<IObraResponse>(
        [OBRA_QUERY_KEY, Number(data.data.ConstructionSiteFk)],
        (old) => {
          if (!old) return old;

          const index = old.Disciplines.findIndex((discipline: any) => {
            return discipline.ConstructionSiteDisciplinesId === data.data.ConstructionSiteDisciplinesId;
          });

          return {
            ...old,
            Disciplines: index !== -1
              ? old.Disciplines.map((discipline: any, i: number) => (i === index ? data.data : discipline))
              : [...old.Disciplines, data.data],
          };
        },
      );

      const msg = variables.Id
        ? updateSuccess('disciplina')
        : createSuccess('disciplina');
      toastHandler.handler({ description: msg, icon: 'success', title: '' });
    },
    onError: async (error: any, variables) => {
      const errorMsg = error.errors
        ? error.errors[0].Message
        : variables.Id ? updateError('disciplina') : createError('disciplina');
      toastHandler.showError(errorMsg);
    },
  });

  return {
    createOrUpdateDiscipline: mutate,
    createOrUpdateDisciplineAsync: mutateAsync,
    isLoading: isPending,
  };
};
